import React from 'react';
export interface DjayMeesterLogoProps {
  size?: 'sm' | 'lg';
  className?: string;
}
/**
 * DjayMeesterLogo — Clean typographic wordmark.
 *
 * No inline SVG character — the real DjayAvatar is shown separately
 * wherever mascot presence is needed. This keeps the logo crisp and
 * consistent with the design system.
 */
export function DjayMeesterLogo({
  size = 'sm',
  className = ''
}: DjayMeesterLogoProps) {
  const isLarge = size === 'lg';
  return <div className={`inline-flex items-baseline gap-1.5 select-none ${className}`} aria-label="Meester djay" role="img" data-id="element-2760">
      <span className={`font-extrabold tracking-tight text-slate-800 ${isLarge ? 'text-4xl md:text-5xl' : 'text-xl'}`} data-id="element-2761">
        Meester
      </span>
      <span className={`font-extrabold italic tracking-tight text-orange-500 ${isLarge ? 'text-4xl md:text-5xl' : 'text-xl'}`} data-id="element-2762">
        djay
      </span>
    </div>;
}